import { IAutoCompleteItem } from './autoComplete';

export interface IPricingPlan {
  id: string | number;
  title: string;
  subscriptionModel: number;
  pricingPeriod: number;
  replacedBy?: number;
  created: Date | string;
  isMegurimDefault?: boolean;
}

export interface IPricingPlanManagement {
  data: IPricingPlan;
  pricingPeriodsList: IAutoCompleteItem[] | [];
  subscriptionModelList: IAutoCompleteItem[] | [];
}

export enum PricingRequirement {
  CellSizesInitialPricings = 1,
  CellSizesRegularUsagePricings = 2,
  CellSizesOveragePricings = 3,
  OneTimePayment = 4,
}

export interface ISubscriptionModelRule {
  allowedPricingPeriods: number[];
  requirements: PricingRequirement[];
}

export interface ISubscriptionModelsRuleResponse {
  [subscriptionModel: number]: ISubscriptionModelRule;
}

export enum ePricingPeriod {
  Hourly = 27001,
  Daily = 27002,
  Yearly = 27003,
  AcademicYear = 27004,
  LeaseCell = 27005,
}

export enum RentalRoute {
  ConcentratedRent = 2001,
  RentYearAndHalf = 2002,
  Purchase = 2003,
  AnnualRent = 2004,
  PurchasePlusService = 2005,
  Off = 2006,
  Residential = 2007,
}

export enum SubscriptionModel {
  pppId = 18001,
  ppuId = 18002,
  smartPersonalCellId = 18003,
  deliveryPermissionWithoutSubscriptionId = 18004,
  deliveryYearlySubscriptionId = 18005,
}
export const subscriptionModelsTypes = {
  [SubscriptionModel.pppId]: 'PayPerPeriod',
  [SubscriptionModel.ppuId]: 'PayPerUse',
  [SubscriptionModel.smartPersonalCellId]: 'SmartPersonalCell',
  [SubscriptionModel.deliveryYearlySubscriptionId]:
    'DeliveryYearlySubscription',
  [SubscriptionModel.deliveryPermissionWithoutSubscriptionId]:
    'DeliveryPermissionWithoutSubscription',
  __default: null,
};

export const RESIDENTIAL_SUBSCRIPTION_MODELS: SubscriptionModel[] = [
  SubscriptionModel.smartPersonalCellId,
  SubscriptionModel.deliveryYearlySubscriptionId,
  SubscriptionModel.deliveryPermissionWithoutSubscriptionId,
];

export enum SiteTypes {
  school = 1,
  migration = 100000001,
  other = 2,
  residential = 3,
}
